export const formatDateDisplay = (value) => {
  if (!value) return "—";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};

export const getTaskStatusBreakdown = (tasks = []) => {
  return tasks.reduce(
    (accumulator, task) => {
      if (task.lifecycleStatus !== "active") {
        return accumulator;
      }

      const { summaryStatus } = task;
      accumulator.total += 1;

      if (summaryStatus === "compliant") {
        accumulator.compliant += 1;
      } else if (summaryStatus === "notDue") {
        accumulator.notDue += 1;
      } else if (summaryStatus === "due") {
        accumulator.due += 1;
      } else if (summaryStatus === "notCompliant") {
        accumulator.notCompliant += 1;
      }

      return accumulator;
    },
    { total: 0, compliant: 0, notDue: 0, due: 0, notCompliant: 0 }
  );
};

export const computeSummaryFromTasks = (tasks = []) => {
  const active = (tasks || []).filter(
    (t) => t && t.lifecycleStatus === "active"
  );
  if (!active.length) {
    return { compliant: 0, notDue: 0, due: 0, notCompliant: 0 };
  }
  const weighted = { compliant: 0, notDue: 0, due: 0, notCompliant: 0 };
  const counts = { compliant: 0, notDue: 0, due: 0, notCompliant: 0 };
  let weightTotal = 0;
  let countTotal = 0;
  active.forEach((task) => {
    const key = task.summaryStatus;
    if (!Object.prototype.hasOwnProperty.call(weighted, key)) return;
    const w = Number(task.weight || 0);
    if (w > 0) {
      weighted[key] += w;
      weightTotal += w;
    } else {
      counts[key] += 1;
      countTotal += 1;
    }
  });
  if (weightTotal > 0) {
    const r = (v) => Math.round(v * 100) / 100;
    return {
      compliant: r(weighted.compliant),
      notDue: r(weighted.notDue),
      due: r(weighted.due),
      notCompliant: r(weighted.notCompliant),
    };
  }
  if (!countTotal) {
    return { compliant: 0, notDue: 0, due: 0, notCompliant: 0 };
  }
  const per = 100 / countTotal;
  const r = (v) => Math.round(v * 100) / 100;
  return {
    compliant: r(counts.compliant * per),
    notDue: r(counts.notDue * per),
    due: r(counts.due * per),
    notCompliant: r(counts.notCompliant * per),
  };
};
